import { render } from "./addIndex.vue?vue&type=template&id=c8f58ffc&scoped=true"
import script from "./addIndex.vue?vue&type=script&lang=js"
export * from "./addIndex.vue?vue&type=script&lang=js"

import "./addIndex.vue?vue&type=style&index=0&id=c8f58ffc&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8f58ffc"]])

export default __exports__